import api from './api';
import { sanitizeBigInt } from '../components/projects_t_engineering/FileUpload/FileUploadBlockchain';

export const blockchainService = {

  //Talvez aqui
  getContractInfo: async (project_id, tokenHeaders) => {
    try {
      if (!project_id) throw new Error('Project ID is required');
      if (!tokenHeaders?.Authorization) throw new Error('Authorization headers are required');

      const response = await api.post('/getcontractinfo/select/', { project_id }, { headers: tokenHeaders });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar informações do contrato:', error);
      throw error;
    }
  },

  getDocumentModelData: async (modelo_GUID, project_id, headers) => {
    try {
      const response = await api.get(`/documentmodels2/${modelo_GUID}/data/`, {
        headers,
        params: { project_id }
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar dados do modelo de documento:', error);
      throw error;
    }
  },

  //funções novas
  getDocumentModelTopics: async (modeloId, projectId, headers) => {
    try {
      const response = await api.get(
        `/documentmodels2/${modeloId}/data/`,
        {
          headers,
          params: {
            project_id: projectId,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("❌ Erro ao buscar modelo e tópicos:", error);
      throw error;
    }
  },

  getTopicItems: async (modeloUuid, topicoUuid, projectId, headers) => {
    const response = await api.post(
      `/documentmodels/${modeloUuid}/topicos/${topicoUuid}/`,
      { project_id: projectId },
      { headers }
    );
    return response.data;
  },

  getDocumentModelProgress: async (modeloId, projectId, headers) => {
    try {
      const response = await api.post(
        `/documentmodels/${modeloId}/progress/`,
        { project_id: projectId },
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error("❌ Erro ao buscar progresso:", error);
      throw error;
    }
  },

  checkTopicStarted: async (projectId, topicoId, headers) => {
    try {
      const response = await api.get(
        `/projects/${projectId}/topicos/${topicoId}/verificar-inicio/`,
        { headers }
      );
      return response.data.iniciado;
    } catch (error) {
      console.error("Erro ao verificar início do tópico:", error);
      throw error;
    }
  },


  createFileManagerControls: async (requestData, headers) => {
    try {
      const response = await api.post(
        `/createfilemanagercontrols/`,
        requestData,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error("❌ Erro ao criar controles de FileManager:", error);
      throw error;
    }
  },


  checkDocumentsConfirmed: async (projectId, modeloId, headers) => {
    try {
      const response = await api.post(
        `/getconfirmeddocumentscount/`,
        {
          project_id: projectId,
        },
        { headers }
      );

      const data = response.data;

      return {
        is_confirmed:
          data.requirements_met.comercial &&
          data.requirements_met.juridico &&
          data.requirements_met.engenharia,

        document_counts: data.document_counts,
        total_confirmed: data.total_confirmed,
      };
    } catch (error) {
      console.error("❌ Erro ao verificar documentos:", error);
      throw error;
    }
  },
  
  getMergedDocuments: async (headers) => {
    try {
      const response = await api.get('/filemanager/documentos_mesclados/', { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar documentos mesclados:', error);
      throw error;
    }
  },

  downloadMergeDocument: async (mergeId, headers) => {
    try {
      const response = await api.post(
        `/filemanager/download_merge/`,
        { merge_id: mergeId },
        {
          headers,
          responseType: 'blob',
        }
      );
      return response;
    } catch (error) {
      console.error("❌ Erro ao baixar o documento mesclado:", error);
      throw error;
    }
  },

  getConfirmedDocumentsCount: async (project_id, headers) => {
    try {
      const requestData = { project_id };
      const response = await api.post('/getconfirmeddocumentscount/', requestData, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar contagem de documentos confirmados:', error);
      throw error;
    }
  },

  getContractStatus: async (project_id, headers) => {
    try {
      const requestData = { project_id };
      const response = await api.post('/filemanagercontract/select/', requestData, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar status do contrato:', error);
      throw error;
    }
  },

  updateContractJsonResponse: async (fileManagerContractId, payload, headers) => {
    try {
      const response = await api.patch(
        `/filemanagercontract/update_json_response/${fileManagerContractId}/`,
        payload,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar JSON response do contrato:', error);
      throw error;
    }
  },

  



  updateFileManagerControls: async (project_id, topic_id, headers) => {
    try {
      const requestData = {
        project_id,
        topic_id
      };
      const response = await api.post('/updatefilemanagercontrols/', requestData, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar controles (updatefilemanagercontrols):', error);
      throw error;
    }
  },

  saveSmartContractData2: async (novoJsonResponse, headers) => {
    try {
      const response = await api.post(
        '/save_smart_contract_data2/insert/',
        { json_response: novoJsonResponse },
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao salvar JSON em smart contract data2:', error);
      throw error;
    }
  },

  updateContractJsonErrorResponse: async (fileManagerContractId, Signer, signature, hashedMessage, jsonErrorResponse, headers) => {
    try {
      const response = await api.patch(
        `/filemanagercontract/update_contract_json_error_response/${fileManagerContractId}/`,
        {
          json_error_response: jsonErrorResponse,
          signer: Signer,
          signature: signature,
          hashedMessage: hashedMessage
        },
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar campo erro JSON response:', error);
      throw error;
    }
  },


  getProjectInfo: async (project_id, headers) => {
    try {
      const requestData = { project_id };
      const response = await api.post('/getinfoproject/select/', requestData, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar informações do projeto:', error);
      throw error;
    }
  },

  // Inserir novo contrato no FileManager
  insertFileManagerContract: async (data, headers) => {
    try {
      const response = await api.post('/filemanagercontract/insert/', data, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao inserir contrato no FileManager:', error);
      throw error;
    }
  },

  cancelDocument: async (guid, senha, justificativa, headers) => {
    try {
      const usuario_id = sessionStorage.getItem('usuario_id');
      const response = await api.get('/documentcancelar/', {
        headers,
        params: { guid, senha, justificativa, usuario_id },
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao cancelar documento:', error);
      throw error;
    }
  },

  atualizarJsonResponseNftBurned: async (
    fileManagerNftId,
    novoJsonResponse,
    ContratoAddress,
    ContratoClienteAddress,
    SignerGeral,
    tokenId,
    signer,
    signature,
    hashedMessage,
    sanitizeBigInt,
    headers
  ) => {
    try {
      const response = await api.patch(
        `/filemanagernft/update_json_response_burned/${fileManagerNftId}/`,
        sanitizeBigInt({
          json_response_burned: novoJsonResponse,
          ContratoAddress,
          ContratoClienteAddress,
          SignerGeral,
          tokenId,
          signer,
          signature,
          hashedMessage
        }),
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar JSON response burned do NFT:', error);
      throw error;
    }
  },

  atualizarDataNftBurned: async (novoJsonResponse, headers) => {
    try {
      const response = await api.post(
        '/save_smart_contract_nft_data_burned/insert/',
        { json_response_burned: novoJsonResponse },
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar JSON response burned do NFT:', error);
      if (error.response) {
        console.error('📄 Detalhes do erro:', error.response.data);
      }
      throw error;
    }
  },

  atualizarNftButtonBurned: async (fileManagerControlId, headers) => {
    try {
      const response = await api.patch(
        `/filemanagercontractnft/update_nft_button_burned/${fileManagerControlId}/`,
        { teste: 'true' },
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar botão NFT burned:', error);
      throw error;
    }
  },

  atualizaCampoErroNftBurn: async (
    fileManagerNftId,
    Signer,
    signature,
    hashedMessage,
    jsonErrorResponse,
    headers
  ) => {
    try {
      const response = await api.patch(
        `/filemanagernft/update_nft_json_error_response_burn/${fileManagerNftId}/`,
        {
          json_error_response: jsonErrorResponse,
          signer: Signer,
          signature,
          hashedMessage,
        },
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar campo erro JSON response do NFT Burn:', error);
      throw error;
    }
  },

  insertFileManagerNft: async (requestData, headers) => {
    try {
      const response = await api.post('/filemanagernft/insert/', requestData, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao inserir NFT no FileManager:', error);
      if (error.response) {
        console.error('📄 Detalhes do erro:', error.response.data);
      }
      throw error;
    }
  },

  identifyDocument: async (document_guid, headers) => {
    try {
      const response = await api.get(`/filemanager/identify_document/${document_guid}/`, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao identificar tabela do documento:', error);
      throw error;
    }
  },

  updateMinted: async (document_guid, headers) => {
    try {
      const response = await api.patch(
        `/filemanager/update_minted/${document_guid}/`,
        {}, // corpo vazio
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao marcar documento como mintado:', error);
      throw error;
    }
  },

  atualizarData2Nft: async (novoJsonResponse, headers) => {
    try {
      const jsonData = {
        json_response: sanitizeBigInt(novoJsonResponse),
      };

      const response = await api.post(
        '/save_smart_contract_nft_data2/insert/',
        jsonData,
        {
          headers: {
            'Content-Type': 'application/json',
            ...headers,
          },
        }
      );

      console.log('✅ atualizarData2Nft - Resposta:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar JSON response (NFT data2):', error);
      if (error.response) {
        console.error('📄 Detalhes do erro:', error.response.data);
      }
      throw error;
    }
  },

  atualizarNftButton: async (fileManagerControlId, headers) => {
    try {
      const response = await api.patch(
        `/filemanagercontractnft/update_nft_button/${fileManagerControlId}/`,
        { teste: 'true' },
        { headers }
      );

      console.log('✅ atualizarNftButton - Resposta:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar botão NFT:', error);
      if (error.response) {
        console.error('📄 Detalhes do erro:', error.response.data);
      }
      throw error;
    }
  },

  atualizaCampoErroNft: async (
    fileManagerNftId,
    signer,
    signature,
    hashedMessage,
    jsonErrorResponse,
    headers
  ) => {
    try {
      const response = await api.patch(
        `/filemanagernft/update_nft_json_error_response/${fileManagerNftId}/`,
        {
          json_error_response: jsonErrorResponse,
          signer,
          signature,
          hashedMessage,
        },
        { headers }
      );

      console.log('✅ atualizaCampoErroNft - Resposta:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar campo erro JSON response (NFT):', error);
      if (error.response) {
        console.error('📄 Detalhes do erro:', error.response.data);
      }
      throw error;
    }
  },

  atualizarJsonResponseNft: async (
    fileManagerNftId,
    novoJsonResponse,
    ContratoAddress,
    ContratoClienteAddress,
    SignerGeral,
    tokenId,
    signer,
    signature,
    hashedMessage,
    headers
  ) => {
    try {
      const jsonData = {
        json_response: sanitizeBigInt(novoJsonResponse),
        ContratoAddress,
        ContratoClienteAddress,
        SignerGeral,
        tokenId: typeof tokenId === 'bigint' ? tokenId.toString() : tokenId,
        signer,
        signature,
        hashedMessage,
      };

      const response = await api.patch(
        `/filemanagernft/update_json_response2/${fileManagerNftId}/`,
        jsonData,
        {
          headers: {
            'Content-Type': 'application/json',
            ...headers,
          },
        }
      );

      console.log('✅ atualizarJsonResponseNft - Resposta:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar JSON response (NFT):', error);

      if (error.response) {
        console.error('📄 Resposta do servidor:', error.response.data);
        console.error('⚠️ Código de status:', error.response.status);
      } else if (error.request) {
        console.error('📡 Nenhuma resposta recebida:', error.request);
      } else {
        console.error('⚙️ Erro ao configurar a requisição:', error.message);
      }

      throw error;
    }
  },

  recarregarTela: async (modelo_GUID, project_id, headers, setData2) => {
    try {
      const response = await api.get(`/documentmodels2/${modelo_GUID}/data/`, {
        headers,
        params: { project_id },
      });

      if (setData2 && typeof setData2 === 'function') {
        setData2({ ...response.data });
      }

      console.log('✅ Dados recarregados com sucesso:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao recarregar dados da tela:', error);
      if (error.response) {
        console.error('📄 Detalhes do erro:', error.response.data);
      }
      throw error;
    }
  },

  //aqui

    downloadDocument: async (documentName, headers) => {
    try {
      const response = await api.post(
        "/documentdownload2/",
        {
          document_name: documentName
        },
        {
          headers,
          responseType: "blob",
        }
      );

      return response.data;
    } catch (error) {
      console.error("❌ Erro ao baixar documento:", error);
      throw error;
    }
  },
  
  downloadDocumento: async (guid, ext, name, project_id, tela_name, headers, documentPath) => {
    try {
      // Preferir path real do banco (upload). Remontar com tela_name quebra
      // quando a tela atual ≠ pasta em que o arquivo foi salvo no S3.
      const document_name =
        (documentPath && String(documentPath).trim()) ||
        `${tela_name}/${guid}.${ext}`;

      const response = await api.post(
        '/documentdownload2/',
        {
          document_name,
          // Caso futuramente precise assinar o PDF:
          // signature: retorno.signature
        },
        {
          headers,
          responseType: 'blob'
        }
      );

      const fileName = name || 'documento';
      const blob = new Blob([response.data], {
        type: response.data.type || 'application/octet-stream',
      });

      const blobURL = URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      downloadLink.href = blobURL;
      downloadLink.download = fileName;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(blobURL);

      console.log(`✅ Documento "${fileName}" baixado com sucesso.`);
    } catch (error) {
      console.error('❌ Erro ao baixar documento:', error);
      if (error.response) {
        console.error('📄 Detalhes do erro:', error.response.data);
      }
      throw error;
    }
  },

  getNftsByDocument: async (params, headers) => {
    try {
      const response = await api.get('/filemanager/get_nfts_by_document/', {
        headers,
        params,
      });

      console.log('✅ NFTs encontradas:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar NFTs por documento:', error);

      if (error.response) {
        console.error('📡 Status:', error.response.status);
        console.error('📥 Detalhes:', error.response.data);
      }

      throw error;
    }
  },

  atualizarData3Nft: async (novoJsonResponse, headers) => {
    try {
      const response = await api.post(
        '/save_smart_contract_nft_data3/insert/',
        { json_response: novoJsonResponse },
        { headers }
      );

      console.log('✅ NFT Data3 atualizada com sucesso:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar JSON response (Data3 NFT):', error);

      if (error.response) {
        console.error('📡 Status:', error.response.status);
        console.error('📄 Detalhes:', error.response.data);
      }

      throw error;
    }
  },

  atualizaCampoErroNftSubstituir: async (fileManagerNftId, Signer, signature, hashedMessage, jsonErrorResponse, headers) => {
    try {
      const response = await api.patch(
        `/filemanagernft/update_nft_json_error_response_substituir/${fileManagerNftId}/`,
        {
          json_error_response: jsonErrorResponse,
          signer: Signer,
          signature,
          hashedMessage,
        },
        { headers }
      );

      console.log('✅ Campo de erro da NFT (substituir) atualizado com sucesso:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar campo erro JSON response (NFT substituir):', error);

      if (error.response) {
        console.error('📡 Status:', error.response.status);
        console.error('📄 Detalhes:', error.response.data);
      }

      throw error;
    }
  },

  getMergedDocumentsByTopic: async (projectId, topicId, modeloId, headers) => {
    try {
      const response = await api.get(`/filemanager/documentos_mesclados_topic/`, {
        params: {
          project_id: projectId,
          topic_id: topicId,
          modelo_id: modeloId,
        },
        headers,
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar documentos mesclados por tópico:', error);
      throw error;
    }
  },

  cancelMerge: async (projectId, modeloDocumentId, topicDocumentId, motivo, senha, headers) => {
    try {
      const response = await api.post('/filemanager/cancela_merge/', {
        project_id: projectId,
        modelo_document_id: modeloDocumentId,
        topic_document_id: topicDocumentId,
        motivo_cancelamento: motivo,
        senha: senha,
      }, { headers });

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao cancelar merge:', error);
      if (error.response) {
        console.error('📄 Detalhes do erro:', error.response.data);
      }
      throw error;
    }
  },

  getActiveDocuments: async (projectId, modeloDocumentId, modeloTopicId, headers) => {
    try {
      const response = await api.get('/filemanager/documentos_ativos/', {
        headers,
        params: {
          project_id: projectId,
          modelo_document_id: modeloDocumentId,
          modelo_topic_id: modeloTopicId,
        },
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar documentos ativos:', error);
      throw error;
    }
  },

  generateMergeDocuments: async (projectId, modeloDocumentId, modeloTopicId, headers) => {
    try {
      const response = await api.post(
        '/filemanager/generate_merge_documents/',
        {
          project_id: projectId,
          modelo_document_id: modeloDocumentId,
          modelo_topic_id: modeloTopicId,
        },
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao gerar merge de documentos:', error);
      throw error;
    }
  },

  saveMergeDocuments: async (projectId, modeloDocumentId, modeloTopicId, base64, mergeGuid, documentIds, headers) => {
    try {
      const response = await api.post(
        '/filemanager/save_merge_documents/',
        {
          project_id: projectId,
          modelo_document_id: modeloDocumentId,
          modelo_topic_id: modeloTopicId,
          merged_pdf_base64: base64,
          merge_guid: mergeGuid,
          documentos_ids: documentIds,
        },
        { headers }
      );
      return response;
    } catch (error) {
      console.error('❌ Erro ao salvar merge de documentos:', error);
      throw error;
    }
  },

  checkMergeMinted: async (mergeId, headers) => {
    try {
      const response = await api.get(`/filemanager/check_merge_minted/${mergeId}/`, {
        headers,
      });
      return response;
    } catch (error) {
      // Repassa o erro para o componente lidar com status 204 etc.
      throw error;
    }
  },

  verificarMergeDocumento: async (documentId, headers) => {
    try {
      const response = await api.get(`/filemanager/verifica_doc/`, {
        params: { document_id: documentId },
        headers,
      });
      return response.data.tem_merge; // true ou false
    } catch (error) {
      console.error("❌ Erro ao verificar merge do documento:", error);
      return false; // assume que não tem merge
    }
  },

  getMergeHistory: async (params, headers) => {
    try {
      const response = await api.get(`/filemanager/merge_history/`, {
        headers,
        params,
      });
      return response.data;
    } catch (error) {
      console.error("❌ Erro ao buscar histórico de merges:", error);
      throw error;
    }
  },

 getDocumentModels: async (headers) => {
    try {
      // Se você tem um endpoint para listar todos os modelos
      const response = await api.get('/documentmodels/', { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar modelos de documento:', error);
      throw error;
    }
  },
};
